import { AmpImage, AmpImageParams } from "types/amplience";
import { Brand } from "types/common";
import buildImageURL from "./buildImageURL";

const getImageLink = (image: AmpImage, opts: { brand: Brand } & Omit<AmpImageParams, "fmt" | "fmt.jpeg.interlaced">) =>
  buildImageURL(image, { ...opts, fmt: "jpg", "fmt.jpeg.interlaced": true });

export default getImageLink;
